import LockTableRow from "./LockTableRow";
import EmptyCellRenderer from "../renderers/EmptyCellRenderer";
import RunnerCellRenderer from "../renderers/RunnerCellRenderer";

export default class RunnerRow extends LockTableRow {
    createRowHeaderRenderer() {
        return new EmptyCellRenderer();
    }

    createLockCellRenderer() {
        return new RunnerCellRenderer();
    }

    accept(visitor, cell) {
        return visitor.visitRunnerRow(cell);
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/rows/RunnerRow.js